const SOLO_SCOPE_TOKEN = '__solo__';
const SUBJECT_SCOPE_PREFIX = 'subject:';

const toTrimmedString = (value) => String(value || '').trim();

export const RESULT_ACCESS_SCOPE_TYPE = Object.freeze({
  SOLO: 'solo',
  REFERENCE: 'reference',
  SUBJECT: 'subject'
});

export const normalizePresetStyleId = (presetStyleId) => {
  const normalized = toTrimmedString(presetStyleId);
  return normalized || null;
};

export const normalizeScopeType = (scopeType, presetStyleId) => {
  const normalizedScopeType = toTrimmedString(scopeType).toLowerCase();
  if (normalizedScopeType === RESULT_ACCESS_SCOPE_TYPE.SUBJECT) {
    return RESULT_ACCESS_SCOPE_TYPE.SUBJECT;
  }
  if (normalizedScopeType === RESULT_ACCESS_SCOPE_TYPE.REFERENCE) {
    return RESULT_ACCESS_SCOPE_TYPE.REFERENCE;
  }
  if (normalizedScopeType === RESULT_ACCESS_SCOPE_TYPE.SOLO) {
    return RESULT_ACCESS_SCOPE_TYPE.SOLO;
  }
  return presetStyleId ? RESULT_ACCESS_SCOPE_TYPE.REFERENCE : RESULT_ACCESS_SCOPE_TYPE.SOLO;
};

export const buildResultAccessScope = ({ originalHashId, presetStyleId = null, scopeType } = {}) => {
  const normalizedOriginalHashId = toTrimmedString(originalHashId);
  if (!normalizedOriginalHashId) {
    return null;
  }

  const normalizedPresetStyleId = normalizePresetStyleId(presetStyleId);
  const resolvedScopeType = normalizeScopeType(scopeType, normalizedPresetStyleId);
  const scopePresetStyleId = resolvedScopeType === RESULT_ACCESS_SCOPE_TYPE.REFERENCE
    ? normalizedPresetStyleId
    : null;

  return {
    scopeType: resolvedScopeType,
    originalHashId: normalizedOriginalHashId,
    presetStyleId: scopePresetStyleId,
    scopeKey: `${normalizedOriginalHashId}::${scopePresetStyleId || SOLO_SCOPE_TOKEN}`
  };
};

export const buildSubjectResultAccessScope = ({
  subjectId,
  originalHashId = '',
  presetStyleId = null
} = {}) => {
  const normalizedSubjectId = toTrimmedString(subjectId);
  if (!normalizedSubjectId) {
    return null;
  }

  return {
    scopeType: RESULT_ACCESS_SCOPE_TYPE.SUBJECT,
    subjectId: normalizedSubjectId,
    originalHashId: toTrimmedString(originalHashId),
    presetStyleId: normalizePresetStyleId(presetStyleId),
    scopeKey: `${SUBJECT_SCOPE_PREFIX}${normalizedSubjectId}`
  };
};

export const resolveResultAccessScope = ({
  routeHashId,
  routePresetStyleId = null,
  analysisTaskContext = null
} = {}) => {
  const contextOriginalHashId = toTrimmedString(analysisTaskContext?.originalHashId);
  const contextPresetStyleId = normalizePresetStyleId(analysisTaskContext?.presetStyleId);
  const normalizedRouteHashId = toTrimmedString(routeHashId);
  const normalizedRoutePresetStyleId = normalizePresetStyleId(routePresetStyleId);

  const originalHashId = contextOriginalHashId || normalizedRouteHashId;
  if (!originalHashId) {
    return null;
  }

  const presetStyleId = normalizedRoutePresetStyleId ?? contextPresetStyleId ?? null;
  return buildResultAccessScope({
    originalHashId,
    presetStyleId
  });
};

export const getScopeKeyFromResultAccessScope = (scope) => toTrimmedString(scope?.scopeKey);
